// Recovered compiled webpack factory 72980. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { o: () => m });
  var n = i(78041),
    s = i(27290),
    r = i(48895),
    o = i(33754),
    a = i(38857),
    l = i(65971);
  let h = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
  };
  function u(t, e) {
    return t * Math.sqrt(1 - e * e);
  }
  let d = ["duration", "bounce"],
    c = ["stiffness", "damping", "mass"];
  function p(t, e) {
    return e.some((e) => void 0 !== t[e]);
  }
  function m(t = h.visualDuration, e = h.bounce) {
    let i,
      l,
      f,
      v,
      y,
      g,
      x = "object" != typeof t ? { visualDuration: t, keyframes: [0, 1], bounce: e } : t,
      { restSpeed: w, restDelta: T } = x,
      b = x.keyframes[0],
      S = x.keyframes[x.keyframes.length - 1],
      P = { done: !1, value: b },
      {
        stiffness: A,
        damping: E,
        mass: M,
        duration: k,
        velocity: V,
        isResolvedFromDuration: C,
      } = (function (t) {
        let e = {
          velocity: h.velocity,
          stiffness: h.stiffness,
          damping: h.damping,
          mass: h.mass,
          isResolvedFromDuration: !1,
          ...t,
        };
        if (!p(t, c) && p(t, d))
          if (((e.velocity = 0), t.visualDuration)) {
            let i = (2 * Math.PI) / (1.2 * t.visualDuration),
              n = i * i,
              s = 2 * (0, r.q)(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(n);
            e = { ...e, mass: h.mass, stiffness: n, damping: s };
          } else {
            let i = (function ({
              duration: t = h.duration,
              bounce: e = h.bounce,
              velocity: i = h.velocity,
              mass: o = h.mass,
            }) {
              let a, l;
              (0, n.$)(
                t <= (0, s.f)(h.maxDuration),
                "Spring duration must be 10 seconds or less",
                "spring-duration-limit",
              );
              let d = 1 - e;
              ((d = (0, r.q)(h.minDamping, h.maxDamping, d)),
                (t = (0, r.q)(h.minDuration, h.maxDuration, (0, s.X)(t))),
                d < 1
                  ? ((a = (e) => {
                      let n = e * d,
                        s = n * t;
                      return 0.001 - ((n - i) / u(e, d)) * Math.exp(-s);
                    }),
                    (l = (e) => {
                      let n = e * d * t,
                        s = Math.pow(d, 2) * Math.pow(e, 2) * t,
                        r = Math.exp(-n),
                        o = u(Math.pow(e, 2), d);
                      return ((n * i + i - s) * r * (-a(e) + 0.001 > 0 ? -1 : 1)) / o;
                    }))
                  : ((a = (e) => -0.001 + Math.exp(-e * t) * ((e - i) * t + 1)),
                    (l = (e) => t * t * (i - e) * Math.exp(-e * t))));
              let c = (function (t, e, i) {
                let n = i;
                for (let i = 1; i < 12; i++) n -= t(n) / e(n);
                return n;
              })(a, l, 5 / t);
              if (((t = (0, s.f)(t)), isNaN(c)))
                return { stiffness: h.stiffness, damping: h.damping, duration: t };
              {
                let e = Math.pow(c, 2) * o;
                return { stiffness: e, damping: 2 * d * Math.sqrt(o * e), duration: t };
              }
            })({ ...t, velocity: 0 });
            (e = { ...e, ...i, mass: h.mass }).isResolvedFromDuration = !0;
          }
        return e;
      })({ ...x, velocity: -(0, s.X)(x.velocity || 0) }),
      D = V || 0,
      R = E / (2 * Math.sqrt(A * M)),
      L = S - b,
      j = (0, s.X)(Math.sqrt(A / M)),
      B = 5 > Math.abs(L);
    if (
      (w || (w = B ? h.restSpeed.granular : h.restSpeed.default),
      T || (T = B ? h.restDelta.granular : h.restDelta.default),
      R < 1)
    )
      ((f = u(j, R)),
        (v = (D + R * j * L) / f),
        (i = (t) => S - Math.exp(-R * j * t) * (v * Math.sin(f * t) + L * Math.cos(f * t))),
        (y = R * j * v + L * f),
        (g = R * j * L - v * f),
        (l = (t) => Math.exp(-R * j * t) * (y * Math.sin(f * t) + g * Math.cos(f * t))));
    else if (1 === R) {
      i = (t) => S - Math.exp(-j * t) * (L + (D + j * L) * t);
      let t = D + j * L;
      l = (e) => Math.exp(-j * e) * (j * t * e - D);
    } else {
      let t = j * Math.sqrt(R * R - 1);
      i = (e) => {
        let i = Math.exp(-R * j * e),
          n = Math.min(t * e, 300);
        return S - (i * ((D + R * j * L) * Math.sinh(n) + t * L * Math.cosh(n))) / t;
      };
      let e = (D + R * j * L) / t,
        n = R * j * e - L * t,
        s = R * j * L - e * t;
      l = (e) => {
        let i = Math.exp(-R * j * e),
          r = Math.min(t * e, 300);
        return i * (n * Math.sinh(r) + s * Math.cosh(r));
      };
    }
    let F = {
      calculatedDuration: (C && k) || null,
      velocity: (t) => (0, s.f)(l(t)),
      next: (t) => {
        if (!C && R < 1) {
          let e = Math.exp(-R * j * t),
            i = Math.sin(f * t),
            n = Math.cos(f * t),
            r = S - e * (v * i + L * n);
          return (
            (P.done = Math.abs((0, s.f)(e * (y * i + g * n))) <= w && Math.abs(S - r) <= T),
            (P.value = P.done ? S : r),
            P
          );
        }
        let e = i(t);
        return (
          C ? (P.done = t >= k) : (P.done = Math.abs((0, s.f)(l(t))) <= w && Math.abs(S - e) <= T),
          (P.value = P.done ? S : e),
          P
        );
      },
      toString: () => {
        let t = Math.min((0, a.t)(F), a.Y),
          e = (0, o.K)((e) => F.next(t * e).value, t, 30);
        return t + "ms " + e;
      },
      toTransition: () => {},
    };
    return F;
  }
  m.applyToOptions = (t) => {
    let e = (0, l.X)(t, 100, m);
    return ((t.ease = e.ease), (t.duration = (0, s.f)(e.duration)), (t.type = "keyframes"), t);
  };
}
